import { AxiosInstance } from "axios";
import { Cart } from "../models/cart";

const CART_API_PREFIX = "/merchandise/cart";

export async function getCart(http: AxiosInstance): Promise<Cart> {
	const body = await http.get<any>(`${CART_API_PREFIX}/`);
	return (body.data || { items: [] }) as Cart;
}

export async function addCartItem(
	http: AxiosInstance,
	variantId: number,
	quantity: number
) {
	await http.post(`${CART_API_PREFIX}/items`, { variantId, quantity });
}

export async function setCartItemQuantity(
	http: AxiosInstance,
	variantId: number,
	quantity: number
) {
	await http.put(`${CART_API_PREFIX}/items`, { variantId, quantity });
}

export async function removeCartItem(http: AxiosInstance, variantId: number) {
	await http.delete(`${CART_API_PREFIX}/items/${variantId}`);
}

export async function clearCart(http: AxiosInstance) {
	await http.delete(`${CART_API_PREFIX}/`);
}

